import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from "@wordpress/element";
import { PIPELINES_SET, } from "../constants";
import { reducer } from "../reducers/pipelines-reducer";
const initialState = {
    pipelines: [],
};
const PipelinesContext = createContext({
    state: initialState,
    pipelinesDispatch: () => { },
});
const PipelinesContextProvider = ({ children, }) => {
    const [state, pipelinesDispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const initialPipelines = window.wpqt.initialPipelines;
        pipelinesDispatch({ type: PIPELINES_SET, payload: initialPipelines });
    }, []);
    return (_jsx(PipelinesContext.Provider, { value: { state, pipelinesDispatch }, children: children }));
};
export { PipelinesContext, PipelinesContextProvider };
